import './MyCalendar.scss';
import React from "react";

import CONSTANT from "../../constants/Constant";

import MobileHeader from "../shared/layout/MobileHeader";
import MainHeaderWrapper from "../shared/layout/HeadWrappers/MainHeaderWrapper";
import Footer from "../shared/layout/Footer";
// import BodyWithLeftMenu from "../shared/layout/BodyWithLeftMenu";
import MyCalenderDetails from "./MyCalenderDetails";
import BodyWithTopMenu from "../shared/layout/BodyWithTopMenu";

const MyCalendar = () => {

    return (
        <>
            {/*<MobileHeader/>*/}
            <div>
                <MainHeaderWrapper/>
                <BodyWithTopMenu pageName={CONSTANT.PAGE_NAME.MY_CALENDAR}>
                    <MyCalenderDetails/>
                </BodyWithTopMenu>
                <Footer/>
            </div>
        </>
    );
}

export default MyCalendar;
